import { API_URL } from "./constants";

const endpoint = (url) => `${API_URL}${url}`;

export const endpoints = {
  contactSync: {
    post: endpoint("api/sync/contacts"),
  },
  productDescriptions: {
    get: endpoint("data/descriptions.json"),
  },
  customerAddresses: {
    get: endpoint("data/addresses.json"),
  },
  prices: {
    get: endpoint("data/prices.json"),
  },
  customerPriceGroups: {
    get: endpoint("data/customer_price_groups.json"),
  },
  deliveryPeriodAssignments: {
    get: endpoint("data/delivery_period_assignments.json"),
  },
  deliveryPeriods: {
    get: endpoint("data/delivery_periods.json"),
  },
  salesforceOrders: {
    post: endpoint("salesforce_orders"),
  },
  salesPackages: {
    get: endpoint("data/sales_packages.json"),
  },
  cache: {
    get: endpoint("data/cache.json"),
  },
  collInfo: {
    get: endpoint("data/coll_info.json"),
  },
  seasons: {
    get: endpoint("data/seasons.json"),
  },
  delivery_options: {
    get: endpoint("data/delivery_options.json"),
  },
  products: {
    get: endpoint("data/products.json"),
  },
  get_your_content: {
    status: (id) => endpoint(`get_your_contents/${id}`),
    generate: (id) => endpoint(`get_your_contents/${id}/generate`),
    download: (id) => endpoint(`get_your_contents/${id}/download`),
  },
};

export default endpoints;
